export default __webpack_public_path__ + "static/media/LFS logo horizontal 2D Black.043a7a4f.jpg";